// extracted by mini-css-extract-plugin
module.exports = {"modalTooltipContainer":"BackButtonWithTooltip_modalTooltipContainer__2ivic","messageContainer":"BackButtonWithTooltip_messageContainer__17Zm1"};